<template>
  <div :class="[{bpanel2:mode>0} ,{bpanel:mode==0}]">
      <div :class="[{chartnamepanel2:mode>0} ,{chartnamepanel:mode==0}]">
        <p> {{ chartname }}</p>
      </div>
      <div :id="'container222' + id"   :class="[{echart2:mode>0} ,{echart:mode==0}]"></div>
  </div>
</template>

<script>


export default {
  name: 'TempCharts',
  components: {

  },
  props: {
    'mode': Number,
    'oee': Number,
    'chartname': String,
    'shap': Number,
    'refresh':Number,
    'id': String
  },
  data() {
    return {
      temperature: 0,
      finish:0,
      myChart:null
    }
  },
  methods: {

    updateChart(data2 = 0) {
      if(this.finish ==0)return;
     // console.log('container222' + this.id)

      var option1 = {
        title: {
          text: ''
        },
        series: [
          {
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 60,
            axisLine: {
              lineStyle: {
                width: 5,
                color: [
                  [0.2, '#37a2da'],
                  [0.8, '#67f067'],
                  [1, '#fd666d']
                ]
              }
            },
            pointer: {
              icon: 'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
              width: 2,

              itemStyle: {
                color: 'inherit'
              },

            },
            axisTick: {
              distance: -5,
              length: 2,
              lineStyle: {
                color: '#fff',
                width: 0
              }
            },
            splitLine: {
              distance: -5,
              length: 0,
              lineStyle: {
                color: '#fff',
                width: 2
              }
            },
            axisLabel: {
              color: 'inherit',
              distance: 5,
              fontSize: 0
            },
            detail: {
              valueAnimation: true,
              formatter: '{value} °C',
              color: 'inherit',
              fontSize: 20
            },
            data: [
              {
                value: data2
              }
            ]
          }

        ]
      }
     // console.log('****************************************'+data2)
      this.myChart.setOption(option1)
    }
  },
  mounted() {
    this.finish =1
    let d = document.getElementById('container222' + this.id)

      if (d == null) return;
     // console.log('oee12222--------------------------------------'+'container222' + this.id)
     if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
        // 3. 已存在则调用 dispose() 方法销毁
      //  this.myChart.dispose();
      }
      this.myChart = this.$echarts.init(d);
      this.updateChart();
  },
  watch: {
    'oee': {
      handler(newVal, oldName) {
        if(newVal == undefined) return;
      //  console.log('oee1****************************************'+newVal)
        this.updateChart(Number(newVal))
        this.temperature = Number(newVal);
   
      },
      immediate: true //true就表示会立即执行
      , deep: true //为true，表示深度监听，这时候就能监测到a值变化

    },
    'refresh': {
      handler(newVal, oldName) {
        if(newVal == undefined) return;
        this.updateChart(this.temperature)
   
      },
      immediate: true //true就表示会立即执行
      , deep: true //为true，表示深度监听，这时候就能监测到a值变化

    }
  }
}
</script>

<style lang="less">



.chartnamepanel {
  width: 100%;
  font-size: 20px;
  text-align: center;
  margin-bottom: 5px;
}

.chartnamepanel2 {
  width: 100%;
  font-size: 16px;
  text-align: center;
  margin-bottom: 0px;
}

.bpanel {
  width:100%; height:100%; margin: 5px;position: relative;
}


.bpanel2 {
  background-color: #222233cc;   border-radius: 10px;
  width:100%; height:100%; margin: 0px;position: relative;
}


.echart {
  width:100%; height:130px; position: absolute;bottom: 0px;
}

.echart2 {
  width:100%; height:110px; position: absolute;bottom: 0px;
}

</style>
